import { Component, OnInit, Input } from '@angular/core';
import { CharacterSpec } from '../validators/allow-characters/allow-characters.model';

interface AllowInputCharacters {
  allowedCharacters?: CharacterSpec;
  disallowedCharacters?: CharacterSpec;
}

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {
  @Input() field: any;
  @Input() group: any;
  @Input() type: any;
  @Input() appearance: any;
  @Input() forceLowerCase: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  processLowercase(event) {
    if (this.forceLowerCase || this.field.forceLowerCase) {
      this.group.get(this.field.fieldKey).setValue(event.target.value.toLowerCase());
    }
  }
}
